// eslint-disable-next-line no-unused-vars
import React, { memo } from 'react';
import { Link } from 'react-router-dom';
import { bool, array, number, node, string } from 'prop-types';
// import { Loading } from '@carbon/react';
import { useTranslation } from 'react-i18next';
import { useTheme } from '@emotion/react';
import styled from '@emotion/styled';

import ProductSkeletonItem from 'Components/Products/ProductSkeletonItem';
import { formatNumber } from 'Utils/formatters';
import { StyledOverlay } from 'Components/Products/Products';
// import UserPropType from 'Types/user';

const StyledFooter = styled.footer`
  padding: 13px 1em 7px !important;

  .totals {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: ${ props => props.theme.products.colors.addToFavoriteText };

    > p {
      font-size: 1em;

      &.price {
        font-weight: 600;
        font-size: 1.25em;
        text-transform: capitalize;
      }

      span {
        margin-right: 3px;
        font-weight: 600;
        text-transform: uppercase;
      }
    }
  }

  hr {
    height: 1px;
    width: 100%;
    border: 0;
    background-color: ${ props => props.theme.products.colors.border };
  }

  .actions {
    width: 100%;

    .submit {
      height: 40px;
      width: 100%;
      margin: 8px 0 4px;
      font-size: 1rem;
      line-height: 40px;
      background-color: ${ props => props.theme.colors.default };
      color: ${ props => props.theme.colors.white } !important;
      text-align: center;
      display: block;
    }
  }
`;

const StyledEmptyContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  padding: 1rem;
  font-size: 1rem;

  a {
    height: 40px;
    padding: 0 1.5rem;
    line-height: 40px;
    text-align: center;
    background-color: ${ props => props.theme.colors.default };
    color: ${ props => props.theme.colors.white };
  }

  p {
    font-weight: 600;
    line-height: 1rem;
    margin-bottom: 10px;
  }
`;

const SkeletonContainer = styled.div`
  margin: 0 -1em;

  .skeleton {
    margin: 9.5px auto;

    > div:first-of-type {
      .cds--skeleton__placeholder {
        max-height: 50px;
        max-width: 50px;
      }
    }

    > div:nth-of-type(2) {
      .cds--skeleton__text:last-of-type {
        display: none;
      }
    }
  }
`;

const StyledContainer = styled.div`
  position: relative;

  > .overlay {
    align-items: center;
    justify-content: center;
    z-index: 100;

    .cds--loading {
      width: 50px;
      height: 50px;
    }
  }
`;

const CartDropdown = memo(props => {
  const {
    items,
    total,
    children,
    // defaultCurrency,
    totalProducts,
    // user,
    // error,
    // open,
    isLoading,
    // wishlists,
    // onMoveToWishlist,
    // onToggle,
    // isFloating
    defaultCurrency
  } = props;

  const theme = useTheme();
  const { t } = useTranslation();

  const renderCartMenu = () => (
    <>
      <div className="productList">
        { children }
      </div>
      <StyledFooter theme={ theme }>
        <div className="totals">
          <p>
            <span>{ t('cart.total') }: </span>
            { totalProducts } { t('products.products') }
          </p>
          <p className="price">
            { formatNumber(total, {
              currency: defaultCurrency
            }) }
          </p>
        </div>
        <hr />
        <div className="actions">
          <Link to="/checkout" className="submit">
            { t('cart.viewCart') }
          </Link>
          {/*<Button className="saveForLater" kind="ghost" onClick={ onMoveToWishlist }>*/ }
          {/*  { t('wishlists.saveForLater') }*/ }
          {/*</Button>*/ }
          {/*<Dropdown
          id={ uniqueId('cartWishlist') }
          label={ t('wishlists.saveForLater') }
          items={
            Object.values(wishlists).map(i => ({
              id: i.id,
              label: i.name
            }))
          }
          onChange={ onMoveToWishlist }
        />*/ }
        </div>
      </StyledFooter>
    </>
  );

  // if (!loading && !cart?.items && !error) {
  if (!items) {
    return (
      <SkeletonContainer>
        <ProductSkeletonItem />
        <ProductSkeletonItem />
        <ProductSkeletonItem />
      </SkeletonContainer>
    );
  }

  return (
    <StyledContainer>
      <StyledOverlay className="overlay" open={ isLoading }>
        {/* { isLoading && <Loading active withOverlay={ false } /> } */}
      </StyledOverlay>
      { items?.length
        ? renderCartMenu()
        : (
          <StyledEmptyContainer>
            <p>{ t('cart.empty') }</p>
            {/*<Link to="/checkout">*/}
            {/*  { t('cart.viewDetails') }*/}
            {/*</Link>*/}
          </StyledEmptyContainer>
        )
      }
    </StyledContainer>
  );
});

CartDropdown.propTypes = {
  items: array,
  children: node,
  total: number,
  totalProducts: number,
  // defaultCurrency: string,
  isLoading: bool,
  // error: string,
  // open: bool,
  // wishlists: object,
  // user: UserPropType,
  // onMoveToWishlist: func,
  // onToggle: func,
  // isFloating: bool
  defaultCurrency: string
};
CartDropdown.displayName = 'CartMenuComponent';

export default CartDropdown;
